@let opkraevning = risikoOpkraevning();
@if (opkraevning) {
  <p-scroll-panel class="h-full">
    <h2>Opkrævningsdetaljer</h2>
    <h3>Letsikring</h3>
    <table class="detail-table">
      <tr>
        <td class="detail-label">Regnr</td>
        <td>{{ opkraevning.regnr }}</td>
      </tr>
      <tr>
        <td class="detail-label">Cpr nr</td>
        <td>{{ opkraevning.cprNummer | cprNummer }}</td>
      </tr>
      <tr>
        <td class="detail-label">Letsikring nr</td>
        <td>{{ opkraevning.letsikringNr }}</td>
        <td>
          <p-button
            label="Vis opkrævningshistorik"
            size="small"
            outlined
            (click)="showHistorik.set(true)" />
        </td>
      </tr>
      <tr>
        <td class="detail-label">Revision</td>
        <td>{{ opkraevning.revisionNr }}</td>
        <td>
          <p-button
            label="Vis detaljer"
            size="small"
            outlined
            (click)="visRevisionDetaljer()" />
        </td>
      </tr>
      <tr>
        <td class="detail-label">Produkt</td>
        <td>{{ opkraevning.produktTypeNummer }}</td>
      </tr>
    </table>
    <h3>Opkrævning</h3>
    <table class="detail-table">
      <tr>
        <td class="detail-label">Opkrævningsreference</td>
        <td>{{ opkraevning.id }}</td>
      </tr>
      <tr>
        <td class="detail-label">Opkrævningstype</td>
        <td>{{ opkraevning.opkraevningsType }}</td>
      </tr>
      <tr>
        <td class="detail-label">Opkrævningsperiode</td>
        <td>
          {{ opkraevning.periodeFra | date: 'dd-MM-yyyy' }} -
          {{ opkraevning.periodeTil | date: 'dd-MM-yyyy' }}
        </td>
      </tr>
      <tr>
        <td class="detail-label">Opkrævningsbeløb</td>
        <td>{{ opkraevning.opkraevningsBeloeb | number: '1.2' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Oprindeligt beløb</td>
        <td>{{ opkraevning.oprindeligOpkraevningsBeloeb | number: '1.2' }}</td>
      </tr>
      <tr>
        <td class="detail-label">Provision</td>
        <td>{{ opkraevning.provision | number: '1.2' }}</td>
      </tr>
    </table>

    <h3>Forløb</h3>
    <p-table [value]="forloeb()" stripedRows class="p-datatable-sm lp-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Status</th>
          <th>Af</th>
          <th>Kilde</th>
          <th>Dato</th>
        </tr>
      </ng-template>
      <ng-template [appTableRow]="forloeb()" pTemplate="body" let-status>
        <tr>
          <td>{{ status.opkraevningStatus }}</td>
          <td>{{ status.oprettetAf }}</td>
          <td>{{ status.oprettelsesKilde }}</td>
          <td class="numbers">
            {{ status.statusTidspunkt | date: 'dd-MM-yyyy HH:mm' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-scroll-panel>

  <p-dialog
    header="Opkrævningshistorik"
    [modal]="true"
    [(visible)]="showHistorik"
    [style]="{
      width: '1000px',
      maxWidth: '1000px',
      minHeight: '80%',
      maxHeight: '80%',
    }">
    <p-table
      [value]="historik()"
      stripedRows
      [scrollable]="true"
      scrollHeight="flex"
      class="p-datatable-sm lp-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Ref</th>
          <th>Periode</th>
          <th>Produkt</th>
          <th>Type</th>
          <th>Beløb</th>
          <th>Provision</th>
          <th>Status</th>
          <th>LO</th>
        </tr>
      </ng-template>
      <ng-template [appTableRow]="historik()" pTemplate="body" let-hist>
        <tr>
          <td>{{ hist.id }}</td>
          <td>
            {{ hist.periodeFra | date: 'dd-MM-yyyy' }} -
            {{ hist.periodeTil | date: 'dd-MM-yyyy' }}
          </td>
          <td>{{ hist.produktTypeNummer }}</td>
          <td class="numbers">
            {{ hist.opkraevningsType }}
          </td>
          <td class="numbers">
            {{ hist.opkraevningsBeloeb | number: '1.2' }}
          </td>
          <td class="numbers">
            {{ hist.provision | number: '1.2' }}
          </td>
          <td>
            {{ hist.opkraevningStatus }}
          </td>
          <td>
            {{ hist.leverandoerOpkraevning?.leverandoerOpkraevningForkortelse }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-dialog>

  <p-dialog
    header="Revision"
    [modal]="true"
    [(visible)]="showRevision"
    [style]="{
      width: '80%',
      maxWidth: '1000px',
      minHeight: '80%',
      maxHeight: '80%',
    }">
    <p-scroll-panel class="h-full overflow-hidden">
      @let letsikring = selectedLetsikring();
      @let revision = selectedRevision();
      @if (letsikring && revision) {
        <app-letsikring-revision
          [editMode]="false"
          [revision]="revision"
          [letsikring]="letsikring" />
      }
    </p-scroll-panel>
  </p-dialog>
}
